import { homeJson as home } from '../JSON/homeJson'
import { devicesJson as devices } from '../JSON/devicesJson'
import { groupsJson as groups } from '../JSON/groupsJson'
import { geofencesJson as geofences } from '../JSON/geofencesJson'
import { usersJson as users } from '../JSON/usersJson'
import { rolesJson as roles } from '../JSON/rolesJson'
import { applicationsJson as applications } from '../JSON/applicationsJson'
import { dashboardGroupsJson as dashboardGroup } from '../JSON/dashboardGroupsJson'
import { dashboardDevicesJson as dashboardDevice } from '../JSON/dashboardDeviceJson'
import { safeWebHomeJson as safeWebHome } from '../JSON/safeWebHomeJson'
import { safeWebListsJson as safeWebLists } from '../JSON/safeWebListsJson'
import { safeWebWordsJson as safeWebWords } from '../JSON/safeWebWordsJson'
import { safeWebPreferencesJson as safeWebPreferences } from '../JSON/safeWebPreferencesJson'
import { preferencesSettingsJson as preferencesSettings } from '../JSON/preferencesSettingsJson'
import { preferencesReportsJson as preferencesReports } from '../JSON/preferencesReportsJson'
import { preferencesLossesJson as preferencesLosses } from '../JSON/preferencesLossesJson'
import { preferencesUseTimeJson as preferencesUseTime } from '../JSON/preferencesUseTimeJson'
import { preferencesGeofenceJson as preferencesGeofence } from '../JSON/preferencesGeofenceJson'
import { preferencesRxartSecureJson as preferencesRxartSecure } from '../JSON/preferencesRxartSecureJson'
import { preferencesServerJson as preferencesServer } from '../JSON/preferencesServerJson'
import { preferencesAgentJson as preferencesAgent } from '../JSON/preferencesAgentJson'
import { reportsJson as reports } from '../JSON/reportsJson'
import { softwareEventsJson as softwareEvents } from '../JSON/softwareEventsJson'
import { devicesEventsJson as devicesEvents } from '../JSON/devicesEventsJson'
import { establishmentsJson as establishments } from '../JSON/establishmentsJson'

export const getJson = (view, language) => {
  let json
  switch (view) {
    case 'home':
      json = home(language)
      break
    case 'devices':
      json = devices(language)
      break
    case 'groups':
      json = groups(language)
      break
    case 'geofences':
      json = geofences(language)
      break
    case 'users':
      json = users(language)
      break
    case 'roles':
      json = roles(language)
      break
    case 'applications':
      json = applications(language)
      break
    case 'dashboardGroup':
      json = dashboardGroup(language)
      break
    case 'dashboardDevice':
      json = dashboardDevice(language)
      break
      /*  case 'safeWebHome':
      json = safeWebHome(language)
      break
    case 'safeWebLists':
      json = safeWebLists(language)
      break
    case 'safeWebWords':
      json = safeWebWords(language)
      break
    case 'safeWebPreferences':
      json = safeWebPreferences(language)
      break */
    case 'preferencesSettings':
      json = preferencesSettings(language)
      break
    case 'preferencesReports':
      json = preferencesReports(language)
      break
    case 'preferencesLosses':
      json = preferencesLosses(language)
      break
    case 'preferencesUseTime':
      json = preferencesUseTime(language)
      break
    case 'preferencesGeofence':
      json = preferencesGeofence(language)
      break
    case 'preferencesRxartSecure':
      json = preferencesRxartSecure(language)
      break
    case 'preferencesServer':
      json = preferencesServer(language)
      break
    case 'preferencesAgent':
      json = preferencesAgent(language)
      break
    case 'reports':
      json = reports(language)
      break
    case 'softwareEvents':
      json = softwareEvents(language)
      break
    case 'devicesEvents':
      json = devicesEvents(language)
      break
    case 'establishments':
      json = establishments(language)
      break
    default:
      break
  }

  return json
}

const jsonCreationWithSelectAllValue = (value, json, language) => {
  const jsonWithSelectAllValue = {}

  Object.keys(json).forEach(key => {
    if (key !== 'columDataTableDevices') jsonWithSelectAllValue[key] = value
    else {
      jsonWithSelectAllValue[key] = defaulColumnsDataTableDevices(language)
    }
  })

  return jsonWithSelectAllValue
}

//* columnas por defecto para el dataTable de devices
export function defaulColumnsDataTableDevices (language) {
  let items

  if (language === 'es') {
    items = [
      { field: 'status_lock', header: 'Estado de bloqueo', sistem: 'all', disabled: true },
      { field: 'type', header: 'Tipo de equipo', sistem: 'all', disabled: true },
      { field: 'id_user', header: 'Usuario del Dispositivo', sistem: 'all', disabled: true },
      { field: 'so', header: 'Sistema Operativo', sistem: 'all', disabled: false },
      { field: 'model', header: 'Modelo', sistem: 'all', disabled: false },
      { field: 'serial_number', header: 'Número de Serie', sistem: 'all', disabled: false },
      { field: 'identity', header: 'Identificador', sistem: 'all', disabled: true },
      { field: 'last_date', header: 'Última Conexión', sistem: 'all', disabled: false },
      { field: 'establishmentCode', header: 'Código de establecimiento', sistem: 'all', disabled: false }
    ]
  } else if (language === 'en') {
    items = [
      { field: 'status_lock', header: 'Locking status', sistem: 'all', disabled: true },
      { field: 'type', header: 'Type of device', sistem: 'all', disabled: true },
      { field: 'id_user', header: 'Device User', sistem: 'all', disabled: true },
      { field: 'so', header: 'Operating System', sistem: 'all', disabled: false },
      { field: 'model', header: 'Model', sistem: 'all', disabled: false },
      { field: 'serial_number', header: 'Serial number', sistem: 'all', disabled: false },
      { field: 'identity', header: 'Identifier', sistem: 'all', disabled: true },
      { field: 'last_date', header: 'Last connection', sistem: 'all', disabled: false },
      { field: 'establishmentCode', header: 'Establishment Code', sistem: 'all', disabled: false }
    ]
  }

  return (items)
}

export const selectedAll = (value, data, set, component, label, edit, language) => {
  // console.log(value, data, set, component, label, edit)

  const json = getJson(label, language)

  if (label === 'dashboardDevice' && edit === true) {
    json.buttonSpeedDial = true
  }

  if (label === 'dashboardGroup' && edit === true) {
    json.buttonSpeedDial = true
  }

  set({
    ...data,
    [label + 'Page']: jsonCreationWithSelectAllValue(value, json, language)
  })
}

export const selectedAllCheckBox = (value, set, role, title, language) => {
  const homeJson = home(language)
  const devicesJson = devices(language)
  const groupsJson = groups(language)
  const geofencesJson = geofences(language)
  const usersJson = users(language)
  const rolesJson = roles(language)
  const applicationsJson = applications(language)
  const dashboardGroupJson = dashboardGroup(language)
  const dashboardDeviceJson = dashboardDevice(language)
  const preferencesSettingsJson = preferencesSettings(language)
  const preferencesReportsJson = preferencesReports(language)
  const preferencesLossesJson = preferencesLosses(language)
  const preferencesUseTimeJson = preferencesUseTime(language)
  const preferencesGeofenceJson = preferencesGeofence(language)
  const preferencesRxartSecureJson = preferencesRxartSecure(language)
  const preferencesServerJson = preferencesServer(language)
  const preferencesAgentJson = preferencesAgent(language)
  const safeWebHomeJson = safeWebHome(language)
  const safeWebListsJson = safeWebLists(language)
  const safeWebWordsJson = safeWebWords(language)
  const safeWebPreferencesJson = safeWebPreferences(language)
  const reportsJson = reports(language)
  const softwareEventsJson = softwareEvents(language)
  const devicesEventsJson = devicesEvents(language)
  const establishmentsJson = establishments(language)

  if (title === 'Editar rol') {
    dashboardGroupJson.buttonSpeedDial = true
    dashboardDeviceJson.buttonSpeedDial = true
  }

  set({
    ...role,
    homePage: jsonCreationWithSelectAllValue(value, homeJson, language),
    devicesPage: jsonCreationWithSelectAllValue(value, devicesJson, language),
    groupsPage: jsonCreationWithSelectAllValue(value, groupsJson, language),
    geofencesPage: jsonCreationWithSelectAllValue(value, geofencesJson, language),
    usersPage: jsonCreationWithSelectAllValue(value, usersJson, language),
    rolesPage: jsonCreationWithSelectAllValue(value, rolesJson, language),
    applicationsPage: jsonCreationWithSelectAllValue(value, applicationsJson, language),
    dashboardGroupPage: jsonCreationWithSelectAllValue(value, dashboardGroupJson, language),
    dashboardDevicePage: jsonCreationWithSelectAllValue(value, dashboardDeviceJson, language),
    preferencesSettingsPage: jsonCreationWithSelectAllValue(value, preferencesSettingsJson, language),
    preferencesReportsPage: jsonCreationWithSelectAllValue(value, preferencesReportsJson, language),
    preferencesLossesPage: jsonCreationWithSelectAllValue(value, preferencesLossesJson, language),
    preferencesUseTimePage: jsonCreationWithSelectAllValue(value, preferencesUseTimeJson, language),
    preferencesGeofencePage: jsonCreationWithSelectAllValue(value, preferencesGeofenceJson, language),
    preferencesRxartSecurePage: jsonCreationWithSelectAllValue(value, preferencesRxartSecureJson, language),
    preferencesServerPage: jsonCreationWithSelectAllValue(value, preferencesServerJson, language),
    preferencesAgentPage: jsonCreationWithSelectAllValue(value, preferencesAgentJson, language),
    safeWebHomePage: jsonCreationWithSelectAllValue(value, safeWebHomeJson, language),
    safeWebListsPage: jsonCreationWithSelectAllValue(value, safeWebListsJson, language),
    safeWebWordsPage: jsonCreationWithSelectAllValue(value, safeWebWordsJson, language),
    safeWebPreferencesPage: jsonCreationWithSelectAllValue(value, safeWebPreferencesJson, language),
    reportsPage: jsonCreationWithSelectAllValue(value, reportsJson, language),
    softwareEventsPage: jsonCreationWithSelectAllValue(value, softwareEventsJson, language),
    devicesEventsPage: jsonCreationWithSelectAllValue(value, devicesEventsJson, language),
    establishmentsPage: jsonCreationWithSelectAllValue(value, establishmentsJson, language)
  })
}

export const checkBoxs = () => {
  const checks = ['home', 'devices', 'groups', 'geofences', 'users', 'roles', 'applications', 'dashboardGroup', 'dashboardDevice', /* 'safeWebHome', 'safeWebLists', 'safeWebWords', 'safeWebPreferences', */ 'preferencesServer', 'preferencesSettings', 'preferencesReports', 'preferencesLosses', 'preferencesUseTime', 'preferencesGeofence', 'preferencesRxartSecure', 'preferencesAgent', 'reports', 'softwareEvents', 'devicesEvents', 'establishments']
  return checks
}
